type PrintiloOptions = {
    html: string|HTMLElement|JQuery,
    printer?: string,
    pageSize?: string,
    deviceScaleFactor?: number,
    printiloUrl?: string,
    origin?: string,
    createProxyUrl?: string,
    downloadProxyUrl?: string,
    cookie?: boolean,
    onStart?: () => void,
    onSuccess?: (url: string) => void,
    onError?: (error: string) => void,
    headerHtml?: string
    footerHtml?: string
}

export default function printilo_print(options: PrintiloOptions) {
    let text = typeof options.html === "string" ? options.html : $(options.html).clone().html();

    if (typeof options.onStart === "function") {
        options.onStart();
    }

    const printUrl = options.createProxyUrl || options.printiloUrl || "https://printilo.nms-mr.com/pdf/";

    const data = new FormData();
    data.append('origin', options.origin || window.location.href);
    if (options.pageSize) {
        data.append('pageSize', options.pageSize);
    }
    if (options.printer) {
        data.append('printer', options.printer);
    }
    if (options.cookie) {
        data.append('cookie', document.cookie);
    }
    if (options.deviceScaleFactor) {
        data.append('deviceScaleFactor', String(options.deviceScaleFactor));
    }

    if (options.headerHtml) {
        data.append('headerHtml', options.headerHtml);
    }

    if (options.footerHtml) {
        data.append('footerHtml', options.footerHtml);
    }

    data.append('originalUrl', options.printiloUrl || "https://printilo.nms-mr.com/pdf/");
    data.append('html', text);

    $.ajax({
            url: printUrl,
            data: data,
            type: 'post',
            method: 'post',
            processData: false,
            contentType: false,
            crossDomain: true,
            success: function (returnData, status) {
                if (status === 'success' && typeof returnData.location !== 'undefined') {
                    const url = (options.downloadProxyUrl ? (options.downloadProxyUrl + "?location=") : '') + returnData.location;
                    if (typeof options.onSuccess === "function") {
                        options.onSuccess(url);
                    } else {
                        if (options.downloadProxyUrl) {
                            window.location.href = options.downloadProxyUrl + "?location=" + returnData.location;
                        } else {
                            window.location.href = returnData.location;
                        }
                    }

                }
            },
            error: function (xhr) {
                if (typeof options.onError === "function") {
                    if (xhr.responseText[0] === "{") {
                        options.onError(JSON.parse(xhr.responseText).error);
                    } else {
                        options.onError(xhr.responseText);
                    }
                }
            }
        }
    );
};